import { makeObservable, observable } from "mobx";

class DevStoreFactory {
    constructor() {
        makeObservable(this, {
            allow_multiple_images: observable,
            allow_cart: observable,
            email_confirmations_enabled: observable,
        });
    }

    allow_multiple_images = false;

    allow_cart = false;

    email_confirmations_enabled = true;
}

export const Dev = new DevStoreFactory();

// Make the dev store available to the window
window["DevStore"] = Dev;
